import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { getRoutes } from "Router/getRoutes";
import {
  login,
  fetchErpData,
  setAuthUser,
  getGdNotifications,
  setCurrentOrganization
} from "Thunks";
import {
  selectUser,
  selectCurrentOrganization,
  selectRouting,
  selectLoggedAs
} from "Selectors";
import {
  getURLEmbeddedParam,
  getURLWithoutHeaderParam,
  getURLParams
} from "Utils";
import {
  setAppIsEmbedded,
  setWithOutHeader,
  setWithoutMenu,
  setTeamCalendarYear
} from "Actions";

import ScrollToTop from "Common/ScrollToTop";
import Layout from "Layout/Layout";
import SelectCommunity from "SelectCommunity/SelectCommunity";
import NotFoundV2 from "./NotFound/NotFoundV2";

export class App extends Component {
  state = {
    loaded: false,
    embedded: false,
    queryToken: "",
    userId: null,
    organization_id: null,
    organizationIsSet: false
  };

  static propTypes = {
    navCommunity: PropTypes.object,
    user: PropTypes.object,
    login: PropTypes.func.isRequired
  };

  UNSAFE_componentWillMount() {
    const { location } = this.props;
    const { embedded } = getURLEmbeddedParam(location);

    if (embedded === "true") {
      this.props.setAppIsEmbedded(true);
    }
  }

  componentWillMount() {
    const { location, setWithOutHeader } = this.props;
    const {
      uaWithoutHeader,
      teamWithoutMenu,
      teamCalendarYear,
      queryToken,
      userId,
      organization_id
    } = getURLParams(location);
    const { withoutHeader } = getURLWithoutHeaderParam(location);
    const withoutMenu = false;
    setWithOutHeader(uaWithoutHeader ? uaWithoutHeader : withoutHeader);
    setWithoutMenu(teamWithoutMenu ? teamWithoutMenu : false);
    teamCalendarYear && setTeamCalendarYear(teamCalendarYear);
    this.setState({
      ...this.state,
      withoutHeader: uaWithoutHeader ? uaWithoutHeader : withoutHeader,
      withoutMenu: teamWithoutMenu ? teamWithoutMenu : withoutMenu,
      queryToken,
      userId,
      organization_id
    });
  }

  componentDidMount() {
    const { queryToken, userId } = this.state;
    if (queryToken && userId) {
      this.props.setAuthUser({
        token: queryToken,
        createdAt: Date.now(),
        expiresIn: 10000,
        id: userId
      });
    } else {
      this.props.login();
    }

    this.waitForErpData();
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (!prevProps.user && this.props.user) {
  //     $("#app-loader")
  //       .fadeOut()
  //       .promise()
  //       .done(() => $("#app-loader").remove());
  //   }
  // }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.user && this.props.user) {
      this.removeAppLoader();
    }
  }

  removeAppLoader = () => {
    $("#app-loader")
      .fadeOut()
      .promise()
      .done(() => $("#app-loader").remove());
  };

  waitForErpData = () => {
    const { currentOrganization } = this.props;

    if (currentOrganization != null) {
      this.props.erpData();
      this.props.gdNotifications();
    } else {
      setTimeout(this.waitForErpData, 150);
    }
  };

  handleGetRoutes = (currentOrganization, loggedAs, spaceAs) => {
    return loggedAs === "GUEST" ? (
      <NotFoundV2
        errorPageType={"ACCESS_DENIED"}
        subText={"applicationNotActivated"}
        accountingSubText={"accountingNotActivated"}
        text={"applicationNotActivatedIndication"}
        buttonIgnored={true}
      />
    ) : (
      getRoutes(currentOrganization, spaceAs)
    );
  };

  render() {
    const { user, routing, loggedAs, spaceAs } = this.props;
    let { currentOrganization } = this.props;

    const { organization_id, organizationIsSet } = this.state;

    if (!user) {
      return null;
      // return <NotFoundV2 errorPageType={"ERROR_404"} />;
    }

    if (organization_id && user.userOrganizations.length > 0) {
      let orgs = user.userOrganizations.filter(org => {
        // eslint-disable-next-line radix
        return parseInt(org.id) === parseInt(organization_id);
      });
      currentOrganization = orgs[0] || null;
      if (!organizationIsSet) {
        this.props.setCurrentOrganization(currentOrganization);
        this.setState({
          ...this.state,
          organizationIsSet: true
        });
      }
    }
    if (
      user &&
      !currentOrganization &&
      user.userOrganizations &&
      user.userOrganizations.length > 0
    ) {
      return <SelectCommunity />;
    }

    return (
      <ScrollToTop location={routing.location}>
        <Layout>
          {this.handleGetRoutes(currentOrganization, loggedAs, spaceAs)}
        </Layout>
      </ScrollToTop>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  currentOrganization: selectCurrentOrganization(state),
  user: selectUser(state),
  loggedAs: selectLoggedAs(state),
  spaceAs: state.auth && state.auth.spaceAs,
  routing: selectRouting(state)
});

const mapDispatchToProps = dispatch => ({
  login: () => dispatch(login()),
  setAuthUser: authInfos => dispatch(setAuthUser(authInfos)),
  setWithOutHeader: withoutHeader => dispatch(setWithOutHeader(withoutHeader)),
  setWithoutMenu: withoutMenu => dispatch(setWithoutMenu(withoutMenu)),
  setAppIsEmbedded: value => dispatch(setAppIsEmbedded(value)),
  erpData: () => dispatch(fetchErpData()),
  setCurrentOrganization: currentOrg =>
    dispatch(setCurrentOrganization(currentOrg)),
  gdNotifications: () => dispatch(getGdNotifications())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/components/App.js